<template>
  <div class="cont">
    <ul class="cart-head">
      <li class="goods-info">
        <span>{{ lang.title_row1 }}</span>
      </li>
      <li class="goods-price">
        <span>{{ lang.title_row2 }}</span>
      </li>
      <li class="goods-num">
        <span>{{ lang.title_row3 }}</span>
      </li>
      <li class="goods-amount">
        <span>{{ lang.title_row4 }}</span>
      </li>
      <li class="action">
        <span>{{ lang.title_row5 }}</span>
      </li>
    </ul>
    <ul class="cart-content">
      <li v-for="(item, index) in carts" :key="index">
        <div class="goods-info">
          <div class="check-box" :class="{ 'cur': item.checked }" @click="selectGoods(index)"></div>
          <el-image :src="item.productimg" lazy @click="selectGoods(index)"></el-image>
          <div @click.stop="$router.push('/goods/info/'+item.productno)" class="info">
            <div class="name">{{ item.productname }}</div>
            <div class="desc">{{ item.briefName }}</div>
          </div>
        </div>
        <div class="goods-price">
          <div
            v-if="item.productpricedoor > 0"
            class="o-price"
          >{{ lang.original_price }}{{ unit }}&nbsp;{{ item.productpricedoor.toFixed(2) }}</div>
          <div class="d-price">
            {{ unit }}
            <span>{{ item.productprice.toFixed(2) }}</span>
          </div>
        </div>
        <div class="goods-num">
          <el-input-number
            v-model="item.productnum"
            :min="1"
            :max="item.stock"
            @change="(value) => handleNumber(value, item)"
          ></el-input-number>
        </div>
        <div class="goods-amount">
          {{ unit }}
          <span>{{ (item.productprice * item.productnum).toFixed(2) }}</span>
        </div>
        <div class="action">
          <svg-icon iconClass="delete" @click="handleDelCart(item.id)" />
          <svg-icon
            style="margin-left: 10px"
            @click="handleCollect(item.productno, index)"
            :iconClass="item.isproductCollection ? 'collect_cur' : 'icon_collect'"
          />
        </div>
      </li>
    </ul>
    <div class="cart-bottom">
      <div class="action-left">
        <div class="item-action" @click="selectAll">
          <div class="check-box" :class="{ 'cur' : allChecked }"></div>
          {{ lang.allselect }}
        </div>
        <div class="item-action" @click="handleDelCart(0)">{{ lang.delete }}</div>
        <div class="item-action" @click="handleEmpty">
          <svg-icon iconClass="delete" />
          {{ lang.empty }}
        </div>
      </div>
      <div class="action-right" @click="handleSettlement">
        <div class="amount">
          <div class="name">{{ lang.total }}：</div>
          {{ unit }}
          <span>{{ totalPrice }}</span>
        </div>
        <div v-if="checkNum > 0" class="btn cur">{{ lang.settle }}({{ checkNum }})</div>
        <div v-else class="btn">{{ lang.settle }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { addproductColl } from '@/api/product'
import { addcart, delcart } from '@/api/cart.js'
import { getbuycartdetail } from '@/api/order'
export default {
  props: {
    list: {
      type: Array,
      default: undefined
    },
    currency: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      carts: []
    }
  },
  watch: {
    list: {
      handler: function (val) {
        this.carts = val
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    lang() {
      return this.$t('cart')
    },
    ...mapGetters(['isLogin', 'location', 'unit']),
    vemId() {
      return this.$route.query.vemId
    },
    checkNum() {
      let i = 0
      this.carts.forEach((item) => {
        if (item.checked) i++
      })
      return i
    },
    totalPrice() {
      let totalPrice = 0
      this.carts.forEach((item) => {
        if (item.checked) {
          totalPrice += item.productnum * item.productprice
        }
      })
      return parseFloat(totalPrice).toFixed(2)
    },
    allChecked: {
      get() {
        return this.checkNum === this.carts.length
      },
      set() {
        let isAllSelected = this.carts.every((item) => {
          return item.checked
        })
        isAllSelected ? true : false
      }
    },
    cartIds() {
      let ids = []
      this.carts.forEach((item) => {
        if (item.checked) {
          ids.push(item.id)
        }
      })
      return ids
    }
  },
  methods: {
    handleSettlement() {
      if (this.cartIds.length === 0) return
      getbuycartdetail({
        cartids: this.cartIds.join(','),
        ...this.location
      }).then((res) => {
        if (res.code === 1) {
          this.$router.push({
            path: '/order/confirm',
            query: {
              ids: this.cartIds.join(',')
            }
          })
        }
      })
    },
    // 收藏
    async handleCollect(id, index) {
      addproductColl({
        productno: id
      }).then((res) => {
        if (res.code === 1) {
          this.carts[index].isproductCollection =
            this.carts[index].isproductCollection === 1 ? 0 : 1
        }
      })
    },
    handleEmpty() {
      const ids = this.carts.map((item) => {
        return item.id
      })
      this.$confirm(this.lang.modal_text1, this.lang.tips, {
        confirmButtonText: this.lang.confirm_text,
        cancelButtonText: this.lang.cancel_text,
        type: 'warning'
      }).then(() => {
        delcart({ cartid: ids.join(',') }).then((res) => {
          if (res.code === 1) {
            this.$message.success(res.msg)
            this.$parent.getCartList()
          }
        })
      })
    },
    handleDelCart(id) {
      if (id === 0 && this.cartIds.length === 0) {
        this.$message.error(this.lang.select_tips)
        return
      }
      this.$confirm(this.lang.modal_text2, this.lang.tips, {
        confirmButtonText: this.lang.confirm_text,
        cancelButtonText: this.lang.cancel_text,
        type: 'warning'
      }).then(() => {
        delcart({ cartid: id === 0 ? this.cartIds.join(',') : id }).then(
          (res) => {
            if (res.code === 1) {
              this.$message.success(res.msg)
              this.$parent.getCartList()
            }
          }
        )
      })
    },
    selectAll() {
      if (this.allChecked) {
        this.carts.forEach((item) => {
          item.checked = false
        })
        this.allChecked = false
      } else {
        this.carts.forEach((item) => {
          item.checked = true
        })
        this.allChecked = true
      }
    },
    selectGoods(index) {
      this.carts[index].checked = !this.carts[index].checked
    },
    handleNumber(value, item) {
      addcart({
        productno: item.productno,
        productnum: value,
        vemId: this.vemId,
        type: 1
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.check-box {
  width: 12px;
  height: 12px;
  border: 1px solid #ec9221;
  border-radius: 50%;
  margin-right: 5px;
  &.cur {
    background: #ec9221;
  }
}

.goods_info_top_mbx {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 44px;
  /deep/ .el-breadcrumb__inner {
    font-size: 14px;
    color: #aaa !important;
    font-weight: 400 !important;
  }
  /deep/ .el-breadcrumb__separator {
    font-weight: 400;
  }
  .el-breadcrumb {
    line-height: 44px;
  }
}

.machine-content {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 30px;
  .cont {
    flex: 1;
    margin-left: 15px;
  }
}

.machine-info {
  background: #fff;
  padding-bottom: 10px;
  width: 300px;
  max-height: 312px;
  .el-image {
    display: flex;
    width: 300px;
    height: 168px;
  }
  .info {
    width: 260px;
    padding: 20px;
    border-bottom: 1px solid #eeeeee;
    .head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 6px;
      .name {
        font-size: 14px;
        color: #4f4f4f;
      }
      .location {
        font-size: 12px;
        color: #aaaaaa;
      }
    }
    .address-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 12px;
      .address {
        color: #aaaaaa;
      }
      .btn {
        color: #0061b5;
      }
    }
  }
  .action-cart {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 270px;
    height: 38px;
    line-height: 38px;
    background: #ec9221;
    border: 1px solid #ec9221;
    border-radius: 12px;
    margin: 15px auto 0;
    box-sizing: border-box;
    font-size: 14px;
    color: #fff;
    border-radius: 12px;
    .cart-icon {
      display: flex;
      align-items: center;
      position: relative;
      margin-right: 20px;
    }
    .svg-icon {
      width: 24px;
      height: 24px;
    }
    a:hover {
      color: #ec9221;
    }
    .shop_car_dot {
      position: absolute;
      top: -2px;
      left: 12px;
      text-align: center;
      line-height: 16px;
      background: #ff0000;
      min-width: 20px;
      font-size: 12px;
      color: #fff;
      border-radius: 10px;
    }
  }
}

.cart-head {
  height: 38px;
  line-height: 38px;
  background: #ffffff;
  border-radius: 12px;
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  li {
    font-size: 14px;
    color: #000;
    span {
      padding-left: 28px;
    }
    &.goods-info {
      width: 450px;
      span {
        padding-left: 160px;
      }
    }
    &.goods-price,
    &.goods-num {
      width: 112px;
    }
    &.goods-amount {
      width: 112px;
    }
  }
}

.cart-content {
  li {
    background: #ffffff;
    border-radius: 12px;
    padding: 15px 0;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    .goods-info {
      cursor: pointer;
      display: flex;
      width: 450px;
      .check-box {
        margin: 33px 10px 0;
      }
      .el-image {
        width: 80px;
        height: 80px;
        margin-right: 15px;
      }
      .name {
        font-size: 14px;
        color: #000;
        padding-bottom: 6px;
      }
      .desc {
        color: #666;
        font-size: 12px;
      }
    }
    .goods-price,
    .goods-num {
      width: 112px;
      /deep/ .el-input-number__increase,
      /deep/ .el-input-number__decrease {
        top: 0;
        background: #fff;
        border: 0;
        width: 22px;
        height: 22px;
        line-height: 22px;
        border-radius: 6px;
        font-size: 14px;
        border: 1px solid #ec9221;
        color: #ffffff;
        i {
          color: #ec9221;
        }
      }
      /deep/ .el-input-number--small {
        width: 90px;
        line-height: 24px;
      }
      /deep/ .el-input-number {
        .el-input {
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .el-input__inner {
          padding: 0;
          width: 50px;
          height: 24px;
          line-height: 24px;
          border: 1px solid #fff;
          color: #000;
          font-size: 14px;
        }
      }
    }
    .goods-price {
      .o-price {
        font-size: 12px;
        color: #000;
        padding-bottom: 4px;
        text-decoration: line-through;
      }
      .d-price {
        color: #ff0000;
        font-size: 12px;
        span {
          padding-left: 5px;
          font-size: 16px;
          font-weight: 700;
        }
      }
    }
    .goods-amount {
      width: 112px;
      padding-left: 10px;
      color: #ff0000;
      font-size: 12px;
      span {
        padding-left: 5px;
        font-size: 16px;
        font-weight: 700;
      }
    }
    .action {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      margin-left: 5px;
    }
  }
}

.cart-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 54px;
  background: #fadfbd;
  border-radius: 30px;
  margin: 120px 0 30px;
  .action-left {
    display: flex;
    align-items: center;
    .item-action {
      display: flex;
      align-items: center;
      color: #4f4f4f;
      font-size: 14px;
      margin-left: 20px;
      font-weight: 400;
      cursor: pointer;
      .svg-icon {
        width: 20px;
        height: 20px;
        margin-right: 7px;
      }
    }
  }
  .action-right {
    display: flex;
    align-items: center;
    .amount {
      display: flex;
      align-items: center;
      padding-right: 15px;
      .name {
        color: #000000;
        font-size: 14px;
      }
      color: #ff0000;
      font-size: 12px;
      span {
        font-size: 16px;
        font-weight: bold;
        padding-left: 6px;
      }
    }
    .btn {
      text-align: center;
      width: 190px;
      height: 54px;
      line-height: 54px;
      background: #aaaaaa;
      border-radius: 0px 30px 30px 0px;
      color: #fff;
      font-size: 18px;
      &.cur {
        background: #ec9221;
      }
    }
  }
}
</style>